export default {
  ProceduceTitle: "How to process invoice in just 3 steps",
  ProceduceTitleV2: "HOW TO PROCESS<BR>INVOICES IN JUST 3 STEPS",
  SendInvoiceTo: "Send invoices to",
  DescriptionAutomatic:
    "The program will process email, check, look-up and process e-invoice.<br> if e-invoice file upload",
  UploadHere: "In here. (zip, xml)",
  InvoiceChecked: "Check invoice",
  SystemAutoChecked:
    "The program automatically checks the information on the invoice to ensure the legality.",
  ViewInvoices: "View list of invoice",
  AccountingSynchronized: "Sync directly to MISA accounting software",
  DescriptionSynchronized:
    "Synchronize with to automatically record and account for invoices<br>MISA SME.NET 2021...",
  ViewGuide: "View help",
  ExportHere: "In case of not using accounting, export excel invoice list",
  SendEmailTo: "You send or forward e-invoice email to ",
  ProceduceStep2:
    "MISA meInvoice automatically processes e-invoices sent to the invoice receiving email.",
  ProceduceStep3:
    "Export or synchronize with accounting software to record and account invoices.",
  StartNow: "Start using",
};
